import styles from './Card.module.css';

const Card: React.FC<any> = (props) => {
  if (props.semEstilo) {
    return(
      <div>
        {props.children}
      </div>
    )
  }

  return (
    <div className={`${styles.container} ${props.className ? props.className : ''}`}>
      {props.children}
    </div>
  );
};

export default Card;
